var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"tick",staticClass:"scoreboard",class:_vm.active ? 'active' : 'non-active',attrs:{"data-repeat":"true","aria-hidden":"true","data-credits":false}},[_c('span',{staticClass:"elevation-6",attrs:{"data-view":"flip"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }